<div mat-dialog-title class="search-detail__header">
  <div class="search-detail__header-text">
    {{ djDetailData.searchResponse?.primaryName }}
    <span class="search-detail__sub-heading">
      (#{{ djDetailData?.searchResponse?.djId }})
    </span>
  </div>
  <div class="search-detail__close" (click)="closeDialog()">
    <img class="themified-white-icon search-detail__close-icon" src="/assets/icons/cross-icon.png" />
  </div>
</div>

<div mat-dialog-content class="search-detail__content">
  <!-- LAST REVIEW DATE -->
  <div class="search-detail__column">
    <div class="search-detail__title">
      LAST REVIEW DATE
    </div>
    <div class="search-detail__text">
      <div class="search-detail__item search-detail__item_md3">
        <span class="search-detail__item-text">{{djDetailData.searchResponse?.modifiedOn ? djDetailData.searchResponse?.modifiedOn : '-'}}</span>
      </div>
    </div>
  </div>

  <!-- ALIASES -->
  <ng-container *ngIf="djDetailData?.searchResponse?.nameDetail">
    <div class="search-detail__column" *ngFor="let section of djDetailData.searchResponse?.nameDetail | keyvalue">
      <div class="search-detail__title">
        {{section.key | uppercase }}
      </div>
      <div class="search-detail__text">
        <ng-container>
          <div class="search-detail__item-header search-detail__item_md6">
            Name
          </div>
          <div class="search-detail__item-header search-detail__item_md6">
            Suffix
          </div>
        </ng-container>
        <ng-template ngFor let-item [ngForOf]="section.value">
          <div class="search-detail__item search-detail__item_md6">
            {{ item.entityName || [item.firstName || '',item.middleName || '',item.surname || ''].join(' ').trim() ||  '-'}}
            <ng-container *ngIf="item.originalScriptName">
              ({{ item.originalScriptName }})
            </ng-container>
          </div>
          <div class="search-detail__item search-detail__item_md6">
            {{ item.suffix || '-'}}
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <!-- GENDER -->
  <div class="search-detail__column" *ngIf="data.recordType === 'INDIVIDUAL'">
    <div class="search-detail__title">
      GENDER
    </div>
    <div class="search-detail__text">
      <div class="search-detail__item search-detail__item_md3">
        <span class="search-detail__item-text">{{djDetailData.searchResponse?.gender ? djDetailData.searchResponse?.gender : '-'}}</span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="djDetailData?.searchResponse?.sanctionsReferences">
    <div class="search-detail__column" >
      <div class="search-detail__title">
        SANCTION
      </div>
      <div class="search-detail__text">
        <ng-container>
          <div class="search-detail__item-header search-detail__item_md3">
            Sanction
          </div>
          <div class="search-detail__item-header search-detail__item_md3">
            Description
          </div>
          <div class="search-detail__item-header search-detail__item_md3">
            Since
          </div>
          <div class="search-detail__item-header search-detail__item_md3">
            To
          </div>
        </ng-container>
        <ng-container *ngFor="let item of djDetailData.searchResponse?.sanctionsReferences">
          <div class="search-detail__item search-detail__item_md3">
            {{ item.sanction || '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{ item.description || '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{ item.sinceDate.trim() || '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{ item.toDate.trim() || '-'}}
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!-- ADDITIONAL DETAILS -->
  <ng-container
    *ngIf="djDetailData?.searchResponse?.countryDetail && djDetailData?.searchResponse?.countryDetail.length > 0">
    <div class="search-detail__column">
      <div class="search-detail__title">
        ADDITIONAL DETAIL
      </div>
      <div class="search-detail__text">
        <ng-template ngFor let-country [ngForOf]="djDetailData.searchResponse?.countryDetail">
          <div class="search-detail__item search-detail__item_md6">
            <span class="search-detail__item-name">{{ country.type }}</span>
            <span class="search-detail__item-text">{{ country.country }}</span>
          </div>
        </ng-template>
        <ng-container
          *ngIf="djDetailData.searchResponse?.dateDetail && djDetailData.searchResponse?.dateDetail.length > 0">
          <ng-template ngFor let-item [ngForOf]="djDetailData.searchResponse?.dateDetail">
            <div class="search-detail__item search-detail__item_md6">
              <span class="search-detail__item-name">{{item.type}}</span>
              <span class="search-detail__item-text">{{ item.date?.split('/').join(' ') || '-' }}</span>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!-- SUPPORTING DOCUMENTS -->
  <ng-container
    *ngIf="djDetailData?.searchResponse?.sourceDescription && djDetailData.searchResponse?.sourceDescription.length > 0">
    <div class="search-detail__column">
      <div class="search-detail__title">
        SOURCE DETAIL
      </div>
      <div class="search-detail__text">
        <ng-template ngFor let-item [ngForOf]="djDetailData.searchResponse?.sourceDescription">
          <div class="search-detail__item search-detail__item_md12">
            <a class="link link_underlined search-detail__item" target="_blank" [href]="convertUrlWithAscensionNumber(item)">{{ item }}</a>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <!-- Roles -->
  <ng-container *ngIf="djDetailData?.searchResponse?.roles">
    <div class="search-detail__column" *ngFor="let section of djDetailData.searchResponse?.roles | keyvalue">
      <div class="search-detail__title">
        {{ section.key | uppercase }}
      </div>
      <div class="search-detail__text">
        <ng-container>
          <div class="search-detail__item-header search-detail__item_md3">
            Occupation
          </div>
          <div class="search-detail__item-header search-detail__item_md3">
            Occupation Category
          </div>
          <div class="search-detail__item-header search-detail__item_md3">
            From
          </div>
          <div class="search-detail__item-header search-detail__item_md3">
            To
          </div>
        </ng-container>
        <ng-template ngFor let-item [ngForOf]="section.value">
          <div class="search-detail__item search-detail__item_md3">
            {{ item.occupation || '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{ item.occupationCategory || '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{ item.fromDate.trim() || '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{ item.toDate.trim() || '-'}}
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <ng-container
    *ngIf="djDetailData?.searchResponse?.associations && djDetailData?.searchResponse?.associations.length > 0">
    <div class="search-detail__column">
      <div class="search-detail__title">
        KNOWN ASSOCIATE
      </div>
      <div class="search-detail__text">
        <ng-template ngFor let-item [ngForOf]="djDetailData.searchResponse?.associations">
          <div class="search-detail__item search-detail__item_md3">
            <span class="search-detail__item-name">{{ item.relationship }}:</span>
            <span class="search-detail__item-text">{{ item.primaryName }}</span>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <!-- PROFILE NOTED -->
  <ng-container *ngIf="djDetailData?.searchResponse?.profileNotes">
    <div class="search-detail__column">
      <div class="search-detail__title">
        PROFILE NOTE
      </div>
      <div class="search-detail__text">
        <div class="search-detail__item search-detail__item_md12">
          {{ djDetailData.searchResponse?.profileNotes }}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- IMAGES -->
  <ng-container
    *ngIf="djDetailData?.searchResponse?.images && djDetailData.searchResponse?.images.length > 0">
    <div class="search-detail__column">
      <div class="search-detail__title">
        IMAGE
      </div>
      <div class="search-detail__text">
        <ng-template ngFor let-item [ngForOf]="djDetailData.searchResponse?.images">
          <div class="search-detail__item search-detail__item_md12">
            <a class="link link_underlined search-detail__item" target="_blank" href="{{item}}">{{ item }}</a>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <!-- DOWNLOAD -->
  <div class="search-detail__column search-detail__column-action" *ngIf="djDetailData.scanType !== 'ODD'">
    <button ubi-round-button mat-button class="btn btn_accent-gradient-rounded" (click)="downloadPDF()">
      Download as PDF
    </button>
  </div>
</div>
